import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import MedicineMaster from "../../HospitalPages/PharmacyMedicalStore/MedicineMaster";
import PurchaseGRNEntry from "../../HospitalPages/PharmacyMedicalStore/PurchaseGRNEntry";
import Sales from "../../HospitalPages/PharmacyMedicalStore/Sales";
import StockManagement from "../../HospitalPages/PharmacyMedicalStore/StockManagement";
import PharmacyBilling from "../../HospitalPages/PharmacyMedicalStore/PharmacyBilling";
import PharmacyReports from "../../HospitalPages/PharmacyMedicalStore/PharmacyReports";
import DashboardCards from "../HospitalDashBoardCards";
import { decrypt } from "../../components/cryptoUtil";
import { includeCardForRoles, ROLES } from "../componenet/heading";

const PharmacyMedicalStoreDashBoard = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
const tokenData = localStorage.getItem("tokenData");
    const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
    const userName = decryptedData.userfullname || "";


    const userRole = decryptedData.userrole || "";

const cardRoles = {
  "Medicine Master": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "Purchase / GRN Entry": [ROLES.RECEPTIONIST],   // only userRole 102 can see
  "Purchase / GRN Entry": [ROLES.RECEPTIONIST],
  "Sales": [ROLES.STAFF],
  "Stock Management": [ROLES.ACCOUNTSECTION],
  "Pharmacy Billing": [ROLES.DOCTOR,ROLES.RECEPTIONIST],
  "Pharmacy Reports": [ROLES.DOCTOR,ROLES.RECEPTIONIST],
};
  const cards = [
    ...includeCardForRoles(cardRoles["Medicine Master"], userRole,
{
      title: "Medicine Master",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
      component: <MedicineMaster />,categary: "👨‍⚕️ Pharmacy Medical Store Data Management",
    }),
    ...includeCardForRoles(cardRoles["Purchase / GRN Entry"], userRole,
{
      title: "Purchase / GRN Entry",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
      component: <PurchaseGRNEntry />,categary: "👨‍⚕️ Pharmacy Medical Store Data Management",
    }),
   
    ...includeCardForRoles(cardRoles["Sales"], userRole,
{
      title: "Sales",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
      component: <Sales />,categary: "👨‍⚕️ Pharmacy Medical Store Data Management",
    }),
    ...includeCardForRoles(cardRoles["Stock Management"], userRole,
{
      title: "Stock Management",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <StockManagement />,categary: "👨‍⚕️ Pharmacy Medical Store Data Management",
    }),

     ...includeCardForRoles(cardRoles["Pharmacy Billing"], userRole,
{
      title: "Pharmacy Billing",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <PharmacyBilling />,categary: "👨‍⚕️ Pharmacy Medical Store Data Management",
    }),

    ...includeCardForRoles(cardRoles["Pharmacy Reports"], userRole,
{
      title: "Pharmacy Reports",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <PharmacyReports />,categary: "👨‍⚕️ Pharmacy Medical Store Data Management",
    }),
  ];

  
     return (
      <DashboardCards
        cards={cards}
        menulabel={1}
        welcomeMessage={
          <Typography variant="h5" align="center" gutterBottom>
            👨‍⚕️ Pharmacy Medical Store Data Management
          </Typography>
        }
      />
    );
  };

export default PharmacyMedicalStoreDashBoard;
